import { MenubarItem } from './MenubarItem';

export class Menubar {
    constructor(domNode) {
        const msgPrefix = 'Menubar constructor argument menubarNode ';
        let element;

        // Check whether menubarNode is a DOM element

        if (!(domNode instanceof Element)) {
            throw new TypeError(msgPrefix + 'is not a DOM Element.');
        }

        // Check whether menubarNode has descendant elements

        if (domNode.childElementCount === 0) {
            throw new Error(msgPrefix + 'has no element children.');
        }

        // Check whether menubarNode has A elements

        element = domNode.firstElementChild;
        while (element) {
            let menubarItem = element.firstElementChild;

            if (element && menubarItem && menubarItem.tagName !== 'A') {
                throw new Error(msgPrefix + 'has child elements are not A elements.');
            }
            element = element.nextElementSibling;
        }

        this.isMenubar = true;

        this.domNode = domNode;

        this.menubarItems = []; // See Menubar init method
        this.firstChars = []; // See Menubar init method

        this.firstItem = null; // See Menubar init method
        this.lastItem = null; // See Menubar init method

        this.hasFocus = false; // See MenubarItem handleFocus, handleBlur
        this.hasHover = false; // See Menubar handleMouseover, handleMouseout
    }

    init() {
        let menubarItem, textContent, numItems, element;

        // Traverse the element children of menubarNode: configure each with
        // menuitem role behavior and store reference in menuitems array.

        element = this.domNode.firstElementChild;

        while (element) {
            let menuElement = element.firstElementChild;

            if (element && menuElement && menuElement.tagName === 'A') {
                menubarItem = new MenubarItem(menuElement, this);
                menubarItem.init();
                this.menubarItems.push(menubarItem);
                textContent = menuElement.textContent.trim();
                this.firstChars.push(textContent.substring(0, 1).toLowerCase());
            }

            element = element.nextElementSibling;
        }

        // Use populated menuitems array to initialize firstItem and lastItem.

        numItems = this.menubarItems.length;
        if (numItems > 0) {
            this.firstItem = this.menubarItems[0];
            this.lastItem = this.menubarItems[numItems - 1];
        }
        this.firstItem.domNode.tabIndex = 0;
    }

    setFocusToItem(newItem) {
        let flag = false;

        for (let i = 0; i < this.menubarItems.length; i++) {
            let mbi = this.menubarItems[i];

            if (mbi.domNode.tabIndex === 0) {
                flag = mbi.domNode.getAttribute('aria-expanded') === 'true';
            }

            mbi.domNode.tabIndex = -1;
            if (mbi.popupMenu) {
                mbi.popupMenu.close();
            }
        }

        newItem.domNode.focus();
        newItem.domNode.tabIndex = 0;

        if (flag && newItem.popupMenu) {
            newItem.popupMenu.open();
        }
    }

    setFocusToFirstItem() {
        this.setFocusToItem(this.firstItem);
    }

    setFocusToLastItem() {
        this.setFocusToItem(this.lastItem);
    }

    setFocusToPreviousItem(currentItem) {
        let index, newItem;

        if (currentItem === this.firstItem) {
            newItem = this.lastItem;
        } else {
            index = this.menubarItems.indexOf(currentItem);
            newItem = this.menubarItems[index - 1];
        }

        this.setFocusToItem(newItem);
    }

    setFocusToNextItem(currentItem) {
        let index, newItem;

        if (currentItem === this.lastItem) {
            newItem = this.firstItem;
        } else {
            index = this.menubarItems.indexOf(currentItem);
            newItem = this.menubarItems[index + 1];
        }

        this.setFocusToItem(newItem);
    }

    setFocusByFirstCharacter(currentItem, char) {
        let start,
            index,
            lowerCasedChar = char.toLowerCase();

        // Get start index for search based on position of currentItem

        start = this.menubarItems.indexOf(currentItem) + 1;
        if (start === this.menubarItems.length) {
            start = 0;
        }

        // Check remaining slots in the menu

        index = this.getIndexFirstChars(start, lowerCasedChar);

        // If not found in remaining slots, check from beginning

        if (index === -1) {
            index = this.getIndexFirstChars(0, lowerCasedChar);
        }

        // If match was found...

        if (index > -1) {
            this.setFocusToItem(this.menubarItems[index]);
        }
    }

    getIndexFirstChars(startIndex, char) {
        for (let i = startIndex; i < this.firstChars.length; i++) {
            if (char === this.firstChars[i]) {
                return i;
            }
        }
        return -1;
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/modules/organisms/header/scripts/a11y-navigation/Menubar.js